var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { UpdateModalEvent } from '../modal/modal.ts';
import sheet from './card.css?polyfill=type-css' ;

let Card = class Card extends LitElement {
    #title_accessor_storage = '';
    get title() { return this.#title_accessor_storage; }
    set title(value) { this.#title_accessor_storage = value; }
    #thumbnail_accessor_storage = '';
    get thumbnail() { return this.#thumbnail_accessor_storage; }
    set thumbnail(value) { this.#thumbnail_accessor_storage = value; }
    #id_accessor_storage = '';
    get id() { return this.#id_accessor_storage; }
    set id(value) { this.#id_accessor_storage = value; }
    static { this.styles = [sheet]; }
    constructor() {
        super();
        this.title;
        this.thumbnail;
        this.id;
    }
    selectItem() {
        const content = `You selected the "${this.title}"`;
        window.dispatchEvent(new UpdateModalEvent(content));
    }
    render() {
        const { title, thumbnail, id } = this;
        if (!title && !thumbnail) {
            return;
        }
        const link = id
            ? html `<a href="/product/${id}/">View Item Details</a>`
            : '';
        return html `
      <div>
        <h3>${title}</h3>
        <img src="${thumbnail}" alt="${title}" loading="lazy" width="100%">
        ${link}
        <button @click="${this.selectItem}">View Item Details</button>
      </div>
    `;
    }
};
__decorate([
    property()
], Card.prototype, "title", null);
__decorate([
    property()
], Card.prototype, "thumbnail", null);
__decorate([
    property()
], Card.prototype, "id", null);
Card = __decorate([
    customElement('app-card')
], Card);
export { Card };
